<template>
    <v-card>
        <v-card-title>
            <span>{{ title }}</span>
        </v-card-title>
        <v-card-subtitle v-if="!!restaurant && isEditing">
            <span>Partner ID: {{ restaurant.id }}</span>
        </v-card-subtitle>
        <v-divider />
        <v-card-text>
            <v-form ref="form" v-model="isValid">
                <p>Partner details</p>
                <v-text-field
                    filled
                    required
                    label="Name *"
                    prepend-inner-icon="mdi-silverware"
                    v-model="restaurant.name"
                    v-bind:rules="validation.required"
                ></v-text-field>
                <v-text-field
                    filled
                    type="number"
                    label="Phone *"
                    prepend-inner-icon="mdi-phone"
                    v-model.number="restaurant.phone"
                    v-bind:rules="validation.required"
                ></v-text-field>
                <v-autocomplete
                    filled
                    label="Location *"
                    prepend-inner-icon="mdi-map-marker"
                    v-model="restaurant.location_id"
                    item-text="name"
                    item-value="id"
                    v-bind:items="$store.state.app.staticData.locations"
                    v-bind:rules="validation.required"
                ></v-autocomplete>
                <v-text-field
                    filled
                    type="number"
                    label="Commission threshold *"
                    prepend-inner-icon="mdi-contrast"
                    append-icon="mdi-currency-inr"
                    v-model.number="restaurant.commission_threshold"
                    v-bind:rules="validation.required"
                ></v-text-field>
                <v-text-field
                    filled
                    type="number"
                    label="Commission percentage (0-100) *"
                    prepend-inner-icon="mdi-percent"
                    v-model.number="restaurant.commission_percentage"
                    v-bind:rules="[
                        ...validation.required,
                        ...validation.percentage
                    ]"
                ></v-text-field>
                <v-divider class="mb-6" />
                <p>Restaurateur details</p>
                <v-text-field
                    filled
                    label="Restaurateur's username *"
                    prepend-inner-icon="mdi-account-key"
                    v-if="restaurant.restaurateur"
                    v-model="restaurant.restaurateur.username"
                    v-bind:rules="validation.required"
                ></v-text-field>
                <v-text-field
                    filled
                    label="Restaurateur's password *"
                    prepend-inner-icon="mdi-lock"
                    v-if="restaurant.restaurateur && !isEditing"
                    v-model="restaurant.restaurateur.password"
                    v-bind:rules="validation.required"
                    v-bind:type="shouldShowPassword ? 'text' : 'password'"
                    v-bind:append-icon="
                        shouldShowPassword ? 'mdi-eye-off' : 'mdi-eye'
                    "
                    v-on:click:append="
                        () => (shouldShowPassword = !shouldShowPassword)
                    "
                ></v-text-field>
                <v-text-field
                    filled
                    label="Confirm password *"
                    prepend-inner-icon="mdi-lock"
                    v-if="restaurant.restaurateur && !isEditing"
                    v-model="restaurant.restaurateur.password_confirmation"
                    v-bind:rules="[
                        ...validation.required,
                        ...validation.confirmMatch
                    ]"
                    v-bind:type="shouldShowPassword ? 'text' : 'password'"
                    v-bind:append-icon="
                        shouldShowPassword ? 'mdi-eye-off' : 'mdi-eye'
                    "
                    v-on:click:append="
                        () => (shouldShowPassword = !shouldShowPassword)
                    "
                ></v-text-field>
                <v-text-field
                    filled
                    label="Restaurateur's name"
                    prepend-inner-icon="mdi-account"
                    v-if="restaurant.restaurateur"
                    v-model="restaurant.restaurateur.name"
                ></v-text-field>
                <v-text-field
                    filled
                    type="number"
                    label="Restaurateur's phone"
                    prepend-inner-icon="mdi-phone"
                    v-if="restaurant.restaurateur"
                    v-model.number="restaurant.restaurateur.phone"
                ></v-text-field>
            </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
            <v-btn
                tile
                class="mx-2"
                v-on:click="$emit('cancel')"
                v-bind:disabled="$store.state.app.loading"
                >Cancel</v-btn
            >
            <v-spacer />
            <v-btn
                tile
                color="primary"
                class="mx-2"
                v-on:click="submit"
                v-bind:loading="$store.state.app.loading"
                >Submit</v-btn
            >
        </v-card-actions>
    </v-card>
</template>

<script>
import snackbar from '@/utils/snackbar';

export default {
    props: {
        restaurant: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            default: 'Partner form'
        },
        // Differentiate edit and create
        isEditing: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isValid: null,
            shouldShowPassword: false,
            validation: {
                required: [v => !!v || 'The field is required'],
                confirmMatch: [
                    v =>
                        v == this.restaurant.restaurateur.password ||
                        'The password does not match'
                ],
                percentage: [v => (v <= 100 && v >= 0) || 'Invalid percentage']
            }
        };
    },
    methods: {
        submit() {
            if (this.isValid) {
                this.$emit('submit');
            } else {
                this.$refs.form.validate();
                snackbar.show('Please check the fields.', 'warning');
            }
        }
    }
};
</script>

<style scoped>
/* Remove stepper on v-text-field type number */
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>
